import { HttpResponse } from '@angular/common/http';

/** Un archivo bajado con el token de Cognito, con el nombre que mandó el servidor. */
export interface ArchivoDescargado {
  blob: Blob;
  nombre: string;
}

/**
 * Saca el nombre de archivo de un `Content-Disposition`
 * (`attachment; filename="x.yaml"` o `filename*=UTF-8''x.yaml`). Si no viene o
 * no se puede leer (CORS sin `exposedHeaders`), devuelve `porDefecto`.
 */
export function nombreDeContentDisposition(valor: string | null | undefined, porDefecto: string): string {
  if (!valor) return porDefecto;
  const ext = /filename\*\s*=\s*(?:UTF-8|utf-8)?''([^;]+)/.exec(valor);
  if (ext?.[1]) {
    try {
      return limpiarNombre(decodeURIComponent(ext[1].trim()), porDefecto);
    } catch {
      // Sigue con el `filename=` plano.
    }
  }
  const plano = /filename\s*=\s*"?([^";]+)"?/.exec(valor);
  return plano?.[1] ? limpiarNombre(plano[1].trim(), porDefecto) : porDefecto;
}

/** Sin rutas ni caracteres raros: es lo que va a `saveAs`. */
function limpiarNombre(nombre: string, porDefecto: string): string {
  const base = nombre.split(/[\\/]/).pop() ?? '';
  const limpio = base.replace(/[^\w.\-() ]+/g, '').trim();
  return limpio || porDefecto;
}

/** Arma el `ArchivoDescargado` a partir de la respuesta cruda (`observe: 'response'`). */
export function archivoDeRespuesta(r: HttpResponse<Blob>, nombrePorDefecto: string): ArchivoDescargado {
  const blob = r.body ?? new Blob([]);
  return { blob, nombre: nombreDeContentDisposition(r.headers?.get('Content-Disposition'), nombrePorDefecto) };
}
